import { c as _c } from "react/compiler-runtime";
import type { FC } from "react";
import { faCog } from "@fortawesome/pro-solid-svg-icons";
import { NavButton } from "../../buttons";
import { Logo } from "../../images";
import { NAV_LINKS } from "../constants";
import "./styles.scss";
const SideNav: FC = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="side-nav__top"><Logo />{NAV_LINKS.filter(_temp).map(_temp2)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <nav className="side-nav">{t0}<div className="side-nav__bottom"><NavButton href="/settings/profile" text="Settings" icon={faCog} /></div></nav>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default SideNav;
function _temp(props) {
  return props.href !== "/settings/profile";
}
function _temp2(props_0) {
  return <NavButton {...props_0} key={props_0.href} />;
}